// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Sf2RS","content":"styles_content__9M8j_"};